import { useTheme } from '@mui/material';
import {
	Bar,
	CartesianGrid,
	BarChart as RechartsBarChart,
	ReferenceLine,
	ResponsiveContainer,
	Tooltip as GraphTooltip,
	XAxis,
	YAxis,
} from 'recharts';

import useFormat from '../../../../../hooks/useFormat';
import { currencyFormatter, N_COLOR, N_MINUS_1_COLOR, tickFormatter } from '../utils/chart';

type dataType = {
	name: string;
	previousValue: number;
	value: number;
};

const BarChart = ({ data, labelFormatter }: { data: dataType[]; labelFormatter: (label: string) => string }) => {
	const { shape, shadows } = useTheme();
	const { isMobileFormat } = useFormat();

	return (
		<ResponsiveContainer width="100%" height="100%">
			<RechartsBarChart
				data={data}
				margin={
					!isMobileFormat
						? {
								top: 32,
								left: -16,
						  }
						: { right: 8, left: 8 }
				}
			>
				<CartesianGrid strokeDasharray={isMobileFormat ? '0' : '3 3'} vertical={!isMobileFormat} />
				<XAxis dataKey="name" height={20} />
				{!isMobileFormat && <YAxis width={80} tickFormatter={tickFormatter} />}
				<ReferenceLine y={0} stroke="#000" />
				<GraphTooltip
					formatter={currencyFormatter}
					labelFormatter={labelFormatter}
					contentStyle={{ borderRadius: shape.borderRadius, boxShadow: shadows[1] }}
				/>
				<Bar dataKey="previousValue" name="N-1" fill={N_MINUS_1_COLOR} />
				<Bar type="monotone" dataKey="value" name="N" fill={N_COLOR} />
			</RechartsBarChart>
		</ResponsiveContainer>
	);
};

export default BarChart;
